import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
import { decideChunkReloadInBrowser, isChunkLoadError, markChunkReloadInBrowser, reloadPage } from '@/utils/chunk-reload'
import Public from './main'
import Admin from './admin'
import Patient from './patient'
import Line from './line'
import LineSystem from './lineSystem'
import LineBauerfeind from './lineBauerfeind'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ASSETS_PUBLIC_PATH ? process.env.VUE_APP_ASSETS_PUBLIC_PATH : '/',
  routes: [
    ...Public,
    ...Admin,
    ...Patient,
    ...Line,
    ...LineSystem,
    ...LineBauerfeind
  ],
  scrollBehavior (to, from, savedPosition) {
    // 如果有保存的位置（如使用瀏覽器返回按鈕），則返回到該位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否則滾動到頁面頂部
      return { x: 0, y: 0 }
    }
  }
})

// 目前這次導覽的目標路由（router.onError 只拿得到 error；beforeEach 在 lazy component 解析之前執行）
let navigationTarget = null

router.beforeEach(async (to, from, next) => {
  navigationTarget = to
  const hasToken = !!getToken()

  if (to.path === '/') {
    return next(hasToken ? '/admin' : '/login')
  }

  if (to.meta && to.meta.requireAuth && !hasToken) {
    return next({ name: 'user-login', query: { redirect: to.fullPath } })
  }

  if (to.name === 'user-login' && hasToken) {
    return next('/admin')
  }

  // 檢查路由是否屬於 LineBauerfeind
  if (to.name && to.name.startsWith('LineBauerfeind')) {
    document.title = 'Bauerfeind';
  }
  // 檢查路由是否屬於 LineSystem
  else if (to.name && to.name.startsWith('LineSystem')) {
    document.title = '康立安管理系統';
  }
  next();
})

// issue #314：路由 lazy component 的 chunk 載入失敗（部署換版後舊 app.js 引用的 chunk 已不在或已換內容）→
// 整頁重新整理一次到目標網址（src/utils/chunk-reload.js：本頁若就是自動重整出來的不再重整、sessionStorage 不可用不重整；
// 列印模式〔?isPrintMode=true，雲端 PDF 渲染器〕不重整）。後台換頁失敗也會整頁導到目標頁——使用者本來就要離開目前畫面。註冊 onError 後 vue-router 不再自己 console.error，
// 所以不重整的情況（含非 chunk 錯誤）照舊印出來。
router.onError(error => {
  if (isChunkLoadError(error)) {
    const to = navigationTarget
    const url = to ? new URL(router.resolve(to.fullPath).href, window.location.href).href : window.location.href
    const isPrintMode = !!(to && to.query && to.query.isPrintMode === 'true')
    if (decideChunkReloadInBrowser({ error, isPrintMode, url }).reload && markChunkReloadInBrowser(url)) {
      reloadPage(url)
      return
    }
  }
  console.error(error)
})

export default router

